import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { EsignatureWebhookEventViewStore } from "../../store";
import { EsignatureWebhookEventView } from "./EsignatureWebhookEventView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type EsignatureWebhookEventDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const EsignatureWebhookEventDrawerContent: React.FC<EsignatureWebhookEventDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new EsignatureWebhookEventViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <EsignatureWebhookEventView esignatureWebhookEventViewStore={viewStore} />
    );
  });
